/* global */
import React from 'react'

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { createRoot } from 'react-dom/client'

import Head from 'components/Head'
import { ThemeContextProvider } from '@nexiahome/ui-common/themes'
import webTheme from '@nexiahome/ui-common/themes/dwa-light-web'

import { ServerErrorContextProvider } from 'hooks/ServerErrorContext'
import { SessionContextProvider } from 'hooks/SessionContext'
import { PremiumFeaturesContextProvider } from 'hooks/PremiumFeaturesContext'
import { WebsocketContextProvider } from 'hooks/WebsocketContext'

import AppRouter from 'routers'

import SignInError from 'pages/SignInError'

import { loadFonts } from 'styles/fonts'
import GlobalStyle from 'styles/base'

import { configureAmplify } from 'helpers/configureAmplify'

import SignOut from 'pages/SignOut'

import Environment from 'helpers/environment'

import { DialogProvider } from 'hooks/useDialog'

const App = async () => {
  if (Environment.isAWSCognito()) {
    await configureAmplify()
  }

  const container = document.getElementById('root')
  if (!container) {
    throw new Error('Root element not found')
  }
  const root = createRoot(container)

  root.render(
    <ThemeContextProvider darkTheme={webTheme} defaultPreference="light" lightTheme={webTheme} ignoreStoredPreference >
      <React.Fragment>
        <div ref={loadFonts} />
        <GlobalStyle />
        <Head />

        <ServerErrorContextProvider>
          <Router>
            <Routes>
              <Route path="/sign_in_error" element={<SignInError />} />
              <Route path="/signout" element={<SignOut />} />
              <Route path="*" element={
                <SessionContextProvider>
                  <PremiumFeaturesContextProvider>
                    <DialogProvider>
                      <WebsocketContextProvider>
                        <AppRouter />
                      </WebsocketContextProvider>
                    </DialogProvider>
                  </PremiumFeaturesContextProvider>
                </SessionContextProvider>}
              />
            </Routes>
          </Router>
        </ServerErrorContextProvider>
      </React.Fragment>
    </ThemeContextProvider>
  )
}

export default App
